export default __webpack_public_path__ + "static/media/download_web_option.e0f6ae3a.png";